
























import AbpBase from "@/lib/abpbase";
import { Component, Prop } from "vue-property-decorator";
import { InsertBIReport } from "@/api/biReport";

@Component
export default class extends AbpBase {
  @Prop() value: boolean;
  saveLoading = false;
  form: any = {};
  rules: any = {
    reportName: [{ required: true, message: "请输入", trigger: "blur" }],
  };

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }

  cancel() {
    this.$emit("input", false);
  }

  save() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        this.saveLoading = true;
        let res = await InsertBIReport(this.form);
        if (res.status === 1) {
          this.$emit("save-success");
          this.$emit("input", false);
        }
        this.saveLoading = false;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/tool/biReport/addOrEdit.vue